import React from 'react'
import withRouter from 'with-router'
import { getShop, setEditLanguage, logout } from '../../modules/shop'
import { getLanguages } from '../../modules/languages'
import { getThemes, setEditTheme } from '../../modules/themes';
import { updateSwitcherLanguages } from '../../modules/switcherConfigurator';
import { getLangifyNotifications } from '../../modules/langifyNotifications'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Route, Link, Switch } from 'react-router-dom'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { alpha } from '@mui/material/styles';
import withStyles from '../../withStylesAdapter';
import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackOutlined from '@mui/icons-material/ArrowBackOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ArrowForwardIosOutlined from '@mui/icons-material/ArrowForwardIosOutlined';
import OfflineBoltRoundedIcon from '@mui/icons-material/OfflineBoltRounded';
import StarsRoundedIcon from '@mui/icons-material/StarsRounded';
import CrownIcon from '../../components/icons/CrownIcon';
import upperFirst from 'lodash/upperFirst';
import { glintOnHover } from '../../theme/glint';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import AddIcon from '@mui/icons-material/Add';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import ContextGuardDialog, { guardReason } from '../../components/ContextGuardDialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { Link as RouterLink } from 'react-router-dom';
import { ParallaxProvider, withController, Parallax } from 'react-scroll-parallax';
import smoothscroll from 'smoothscroll-polyfill';
import { withSnackbar } from '../../utils/withSnackbar';

import { MainListItems, SecondaryListItems } from './Navigation';
import Login from '../auth'
import Dashboard from '../dashboard'
import Theme from '../theme'
import NewTheme from '../new_theme'
import StaticTheme from '../static_theme'
import Products from '../products'
import Collections from '../collections'
import TranslatableResources from '../translatable_resources'
import { getRoutedTranslatableResourceSections } from '../../config/translatableResourceSections'
import Pages from '../pages'
import Navigation from '../navigation'
import Blogs from '../blogs'
import Articles from '../articles'
import Notifications from '../notifications'
import NewNotifications from '../new_notifications'
import SMSNotifications from '../sms_notifications'
import Images from '../images'
import Shop from '../shop'
import ShopMetafields from '../shop_metafields'
import NewCustom from '../new_custom'
import About from '../about'
import Static from '../static'
import Design from '../design'
import PatchNotes from '../patchnotes'
import Settings from '../settings'
import Admin from '../admin'
import Profile from '../profile'
import ProfileCharges from '../profile/charges'
import ProfileTickets from '../profile/tickets'
import ProfilePlans from '../profile/plans'
import WordsLog from '../machinetranslation/wordslog'
import ProfileGlossary from '../machinetranslation/glossary'
import BulkConfiguration from '../machinetranslation/settings'
import RecommendedApps from '../recommended_apps'
import MetaObjects from '../metaobjects'
import AppEmbeds from '../app_embeds'
import AppIntegrations from '../app_integrations'
import AppIntegration from '../app_integrations/app_index.js'
import SizeChartApp from '../app_integrations/size_chart_index.js'
import BulkSettings from '../machinetranslation/bulksettings'

import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import Logo from '../design/logo.svg?react';
import { RestrictedRoute } from '../../helper.js'
import { hasBulkTranslationAccess } from '../../modules/config';
import EmptyView from '../../components/EmptyView';
import Search from '../../components/Search';
import LoadingIndicator from '../../components/LoadingIndicator';
import ErrorBoundary from '../../components/ErrorBoundary';
import RechargeConfirmation from '../../components/RechargeConfirmation';
import SatisfactionQuote from '../../components/SatisfactionQuote'
import { BulkTranslationStatusCard } from '../../components/BulkTranslations';
import { BulkTranslationSnackbarManager } from '../../components/SnackbarItems';

import '../../i18n';
import { Trans, withTranslation, useTranslation } from 'react-i18next';

import API from '../../api/api';
import ImportReviewDialog from '../../components/ImportReviewDialog';

import $ from 'jquery';
import SupportSpeedDial from '../../components/SupportSpeedDial';
import AppLoadError from '../../components/AppLoadError';
import * as Sentry from '@sentry/react';
import appEmbeds from '../../modules/appEmbeds.js';

// the open drawer's width lives in a CSS variable so the navigation can widen it for long labels
const drawerWidth = 'var(--ly-drawer-width, 240px)';

const notifications = [
  {
    id: 1,
    type: 'info',
    title: 'Lorem ipsum',
    body: 'Lorem ipsum dolor set amit, consetetur sadipscing elitr.',
    viewed: false,
  },
  {
    id: 2,
    type: 'success',
    title: 'Lorem ipsum',
    body: 'Lorem ipsum consetetur dolor set amit',
    viewed: false,
  }
];

// Where a theme switch changes what is on screen. Outside these routes the header's theme
// selector is disabled, and a theme switch may not claim to interrupt anything.
// '/' matches the dashboard exactly, not every route below it. `/images` is deliberately absent:
// that section is not in use.
const THEME_SCOPED_ROUTES = ['/', '/theme', '/static_theme', '/appembeds'];
// first path segment -> sidebar label key (navigation.primary.*) for the theme switch hint
const THEME_FREE_SECTION_LABELS = {
  products: 'products', collections: 'collections', pages: 'pages', navigation: 'navigation', blogs: 'blogs',
  articles: 'articles', notifications: 'notifications', shop: 'shop', shop_metafields: 'shopMetafields',
  metaobjects: 'metaobjects', appintegrations: 'integratedApps', custom: 'custom', filters: 'filters',
};

// areas that hold no translations at all (glossary, words log, bulk settings, app settings): naming
// them in the hint would read as "translations for machine translation"
const THEME_FREE_NON_SECTIONS = ['machinetranslation', 'profile', 'settings'];
const PAGES_WITHOUT_LANGUAGE = ['', 'profile', 'settings', 'machinetranslation', 'about', 'changelog', 'patchnotes', 'recommended_apps', 'design', 'hidden_admin', 'login'];

class App extends React.Component {

  displayedNotifications = [];

  static propTypes = {
    parallaxController: PropTypes.object,
  };

  constructor(props) {
    super(props);

    window.mainFrameRef = React.createRef();

    window.dev = {
      clearHost: () => {
        if(API.clearHost()) {
          window.location.reload();
        }
      },
      changeHost: (host) => {
        if(API.changeHost(host)) {
          window.location.reload();
        }
      },
      enableLogging: () => {
        API.enableLogging(response => {
          response.success ? console.log('%clogging enabled', 'color:#006600') : console.log('%cerror', 'color:#660000');
        })
        return 'pending...';
      },
      disableLogging: () => {
        API.disableLogging(response => {
          response.success ? console.log('%clogging disabled', 'color:#006600') : console.log('%cerror', 'color:#660000');
        })
        return 'pending...';
      },
    }

    this.mobileQuery = window.matchMedia('(max-width: 750px)');

    this.state = {
      open: localStorage.getItem('sidebarOpened') ? (localStorage.getItem('sidebarOpened') === 'true') : true,
      isMobile: this.mobileQuery.matches,
      theme: '',
      showNewChargeDialog: this.props.shop.shop.update_charge ? true : false,
      pendingContextSwitch: null,
    };
  }

  getScripts = (scripts, callback) => {
    var progress = 0;
    scripts.forEach(function(script) { 
      $.getScript(script, function () {
        if (++progress == scripts.length) callback();
      }); 
    });
  }

  handleMobileChange = (e) => {
    this.setState({ isMobile: e.matches });
    if (e.matches && this.state.open) {
      this.handleDrawerClose();
    }
  }

  // After a word pack purchase the API redirects back with ?purchase=wordpack&status=...&words=...
  // Show the result once and drop the parameters, so a reload does not show it again.
  showWordpackPurchaseResult = () => {
    const params = new URLSearchParams(window.location.search);
    if(params.get('purchase') !== 'wordpack') {
      return;
    }
    const { t } = this.props;
    if(params.get('status') === 'active') {
      this.props.enqueueSnackbar(t('buyAutoTranslationWordsDialog.purchaseSuccess', { words: params.get('words') || '' }), { variant: 'success' });
    } else {
      this.props.enqueueSnackbar(t('buyAutoTranslationWordsDialog.purchaseDeclined'), { variant: 'error' });
    }
    ['purchase', 'status', 'charge_id', 'message', 'words'].forEach(key => params.delete(key));
    const search = params.toString();
    this.props.history.replace({ pathname: window.location.pathname, search: search ? '?' + search : '', hash: window.location.hash });
  }

  componentDidMount = () => {
    this.showWordpackPurchaseResult();
    this.mobileQuery.addEventListener('change', this.handleMobileChange);
    if (this.state.isMobile && this.state.open) {
      this.handleDrawerClose();
    }
    //const richtextEditorVersion = (props.langifyFeatures.find(x => x.name === 'editor_v2') && props.langifyFeatures.find(x => x.name === 'editor_v2').is_enabled) ? 'v2' : 'v1';
    const redactorSources = [
      '/redactorx/redactorx-langify.js',
      '/redactor/redactor.js'
    ];
    const redactorScripts =  [
      '/redactorx/plugins/alignment/alignment.js',
      '/redactorx/plugins/underline/underline.js',
      '/redactorx/plugins/imageposition/imageposition.js',
      '/redactorx/plugins/imageresize/imageresize.js',
      '/redactorx/plugins/inlineformat/inlineformat.js',
      '/redactorx/plugins/removeformat/removeformat.js',
      '/redactorx/plugins/readonly/readonly.js',
      '/redactorx/plugins/fontcolor/fontcolor.js',
      `/redactorx/locale/${this.props.i18n.language}.js`,
      
      '/redactor/plugins/fontcolor/fontcolor.js',
      '/redactor/plugins/fontsize/fontsize.js',
      '/redactor/plugins/table/table.js',
      '/redactor/plugins/imagemanager/imagemanager.js',
      '/redactor/plugins/video/video.js',
      '/redactor/plugins/fontfamily/fontfamily.js',
      '/redactor/plugins/alignment/alignment.js',
      '/redactor/plugins/pastemanager/pastemanager.js',
      '/redactor/plugins/noeditor/noeditor.js'
    ];

    this.getScripts(redactorSources, () => {
      this.getScripts(redactorScripts, () => {
        API.startSession(data => {
          if(data.success == true) {
            if(data.nextPath) {
              this.props.history.push(data.nextPath);
            }
            this.props.getShop();
            this.props.getLanguages();
            this.props.getThemes();


            //this.setState({showUpdateInformation: true});
          }
        });

        // kick off the polyfill!
        smoothscroll.polyfill();

        this.lastLocation = this.props.location.pathname;
        this.props.history.listen((location, action) => {
          if(this.lastLocation.split('/')[1] !== location.pathname.split('/')[1]) {
            this.lastLocation = location.pathname;
            if(window.mainFrameRef && window.mainFrameRef.scroll) {
              window.mainFrameRef.scroll({top: 0, behavior: 'smooth' });        
            }
          }
        });
      });
    });
  };

  componentWillReceiveProps = (newProps) => {
    if(this.props.shop.shop.update_charge !== newProps.shop.shop.update_charge) {
      this.setState({'showNewChargeDialog': newProps.shop.shop.update_charge})
    }
  }

  componentDidUpdate = () => {

    // without a loaded shop (GET shop failed) render() shows the error page, nothing to prefill
    if(this.props.shop.get_shop_pending === false && this.props.languages.get_languages_pending === false && this.props.themes.get_themes_pending === false && this.props.shop.shop.charge) {
      // Freshdesk
      window.FreshworksWidget('prefill', 'ticketForm', {
        subject: `Support request for langify v2`,
        custom_fields: {
          cf_shop_url: this.props.shop.shop.url,
          cf_shopify_plan: this.props.shop.shop.charge.name,
          cf_langify_version: 'v2',
        }
      });      
      window.FreshworksWidget('show');
      window.FreshworksWidget('hide', 'launcher');
      window.FreshworksWidget('hide', 'ticketForm', ['custom_fields.cf_shop_url', 'custom_fields.cf_shopify_plan', 'custom_fields.cf_langify_version']);

      // Start langify notification fetching
      //setInterval(this.checkLangifyNotificationUpdates, 1000 * 60 * 5);
      //this.checkLangifyNotificationUpdates();
    }

    this.setupContextMarquee();
  }

  // componentDidCatch alone makes App a boundary that renders nothing, i.e. a white page
  static getDerivedStateFromError(error) {
    return { renderError: error };
  }

  componentDidCatch(error, errorInfo) {
    this.hasError = true;
    Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo?.componentStack } } });
  }

  componentWillUnmount() {
    clearInterval(this.contextSwitchWatch);
    if (this._marqueeAnimations) {
      this._marqueeAnimations.forEach(a => a.cancel());
    }
    this.mobileQuery.removeEventListener('change', this.handleMobileChange);
    if(!this.hasError && window.mainFrameRef) {
      this.props.parallaxController.destroy();
    }
  }
  
  setMainFrameRef = (ref) => {
    window.mainFrameRef = ref;

    if(!this.hasError && window.mainFrameRef) {
      this.props.parallaxController.updateScrollContainer(window.mainFrameRef);
      this.props.parallaxController.update();
    }
  };

  handleDrawerOpen = (focusSelector) => {
    localStorage.setItem('sidebarOpened', 'true');
    this.setState({ open: true }, () => {
      if (focusSelector) {
        setTimeout(() => {
          const inputEl = document.getElementById(focusSelector);
          const trigger = inputEl?.closest('.MuiInputBase-root')?.querySelector('[role="combobox"]');
          if (trigger) {
            trigger.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
          }
        }, 350);
      }
    });
  };

  handleDrawerClose = () => {
    localStorage.setItem('sidebarOpened', 'false');
    this.setState({ open: false });
  };

  setupContextMarquee = () => {
    if (this._marqueeAnimations) {
      this._marqueeAnimations.forEach(a => a.cancel());
    }
    this._marqueeAnimations = [];

    const items = document.querySelectorAll('.mobile-context-item');
    items.forEach(item => {
      const wrapper = item.querySelector('.context-label-wrapper');
      const label = item.querySelector('.context-label');
      if (!wrapper || !label) return;
      const overflow = label.scrollWidth - wrapper.clientWidth;
      if (overflow > 0) {
        const pause = 3000;
        const scroll = Math.max(1500, overflow * 30);
        const duration = 2 * scroll + 2 * pause;
        const p1 = pause / duration;
        const p2 = (pause + scroll) / duration;
        const p3 = (2 * pause + scroll) / duration;
        const animation = label.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(0)', offset: p1 },
          { transform: `translateX(-${overflow}px)`, offset: p2 },
          { transform: `translateX(-${overflow}px)`, offset: p3 },
          { transform: 'translateX(0)' },
        ], {
          duration,
          iterations: Infinity,
          easing: 'ease-in-out',
        });
        this._marqueeAnimations.push(animation);
      }
    });
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  logout = () => {
    this.props.logout()
  }

  handleSelectTheme = (event) => {
    //API.addV3Scripts(event.target.value, (res) => {});
    //this.props.updateSwitcherLanguages(this.props.languages.languages, event.target.value, this.props.themes.themes);
    this.requestContextSwitch('theme', event.target.value);
  }

  isThemeRelevantRoute = () => {
    const path = (this.props.location && this.props.location.pathname) || '';
    return THEME_SCOPED_ROUTES.some(route => path === route || path.startsWith(route + '/'));
  }

  // why the theme switch is greyed here, naming the section by its sidebar label where there is one
  themeSwitchDisabledHint = () => {
    const segment = ((this.props.location && this.props.location.pathname) || '').split('/')[1] || '';
    if(THEME_FREE_NON_SECTIONS.includes(segment)) return this.props.t('navigation.themeSwitchDisabledHintArea');
    const sectionKey = THEME_FREE_SECTION_LABELS[segment];
    if(!sectionKey) return this.props.t('navigation.themeSwitchDisabledHint');
    return this.props.t('navigation.themeSwitchDisabledHintSection', { section: this.props.t(`navigation.primary.${sectionKey}`) });
  }

  // Switching while a save runs interrupts it, and switching while a machine translation is
  // running leaves words spent on a result the merchant will not see until they switch back.
  // Neither is blocked - they are told what it costs and decide themselves. Only what this
  // particular switch actually interrupts is warned about: a theme switch does not stop a save
  // that declared a language alone.
  // Only what this switch interrupts: a theme switch touches neither a language-scoped save
  // nor edits outside the theme routes.
  switchGuardReason = (type) => (type === 'theme')
    ? guardReason({
        translating: API.isProtectedRunActive() && this.isThemeRelevantRoute(),
        saving: this.props.isSavingThemeScoped,
        unsaved: this.props.hasUnsavedEdits && this.isThemeRelevantRoute(),
      })
    : guardReason({
        translating: API.isProtectedRunActive(),
        saving: this.props.isSavingLanguageScoped,
        unsaved: this.props.hasUnsavedEdits,
      });

  requestContextSwitch = (type, value) => {
    if(this.switchGuardReason(type) !== null) {
      this.setState({pendingContextSwitch: {type: type, value: value}});
      // The run state is not in the store, so a translation that ends without a save would not
      // re-render the open dialog on its own.
      this.contextSwitchWatch = setInterval(() => this.forceUpdate(), 500);
      return;
    }
    this.applyContextSwitch(type, value);
  }

  closeContextSwitchPrompt = () => {
    clearInterval(this.contextSwitchWatch);
    this.setState({pendingContextSwitch: null});
  }

  applyContextSwitch = (type, value) => {
    this.closeContextSwitchPrompt();
    if(type === 'theme') {
      // Mirrors the dialog: only on the theme routes does a theme switch interrupt a running
      // translation - its save reads the theme at save time, so left running it would put the
      // old theme's strings under the new one. Elsewhere the run is language work and survives.
      if(this.isThemeRelevantRoute()) {
        API.cancelProtectedRun();
      }
      this.props.setEditTheme(value);
      setTimeout(() => this.setupContextMarquee(), 100);
    } else {
      this.props.setEditLanguage(value);
    }
  }

  renderContextSwitchPrompt = () => {
    const pending = this.state.pendingContextSwitch;
    if(!pending) return null;
    return (
      <ContextGuardDialog
        open={true}
        reason={this.switchGuardReason(pending.type)}
        action="switch"
        onCancel={this.closeContextSwitchPrompt}
        onConfirm={() => this.applyContextSwitch(pending.type, pending.value)}
      />
    );
  }

  updateCharge = () => {
    API.updateCharge(response => {console.log("!")})
  }

  checkLangifyNotificationUpdates = () => {
    this.props.getLangifyNotifications(response => {
      console.log(response);
    });
    notifications.map((notification, i) => {

      if(this.displayedNotifications.find(x => x === notification.id)) {
        return false;
      }
      this.displayedNotifications.push(notification.id);

      setTimeout(() => {
        this.props.enqueueSnackbar(notification.body, {
          variant: notification.type,
          persist: notification.persist,
          action: (key) => (
            <React.Fragment>
                <Button
                    size='small'
                    onClick={() => alert(`Clicked on action of snackbar with id: ${key}`)}
                >
                    Detail
                </Button>
                <Button size='small' onClick={() => this.props.closeSnackbar(key)}>
                    Dismiss
                </Button>
            </React.Fragment>
          )
        });
      }, 2000 + (500*i))

    });
  }

  // a language the shop can translate into; render() falls back to the first of them when none
  // is selected, so the edit language itself is never the thing missing
  hasTranslationLanguage = () => this.props.languages.languages.some(x => !x.base && !x.removed_on_shopify);

  // without a translation language the translatable pages have nothing to load (their requests
  // would carry the "Language" placeholder as id); the pages that don't translate stay reachable
  needsLanguageFirst = () => {
    const section = this.props.location.pathname.split('/')[1] || '';
    return !this.hasTranslationLanguage() && !PAGES_WITHOUT_LANGUAGE.includes(section);
  }

  // Reports a click on the header's plan button to Google Analytics (gtag is defined in
  // index.html). The free plan shows "Upgrade", every other plan shows the current plan name
  trackPlanButtonClick = (plan, isFree) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'header_plan_button_click', {
      current_plan_name: plan,
      button_variant: isFree ? 'upgrade' : 'current_plan',
    });
  }

  renderPlanButton = () => {
    const { t, classes } = this.props;
    const plan = this.props.shop.shop.charge?.name?.toLowerCase();
    if (!plan) return null;

    const isFree = plan === 'free';
    const icons = { free: <RocketLaunchRoundedIcon />, basic: <OfflineBoltRoundedIcon />, growth: <StarsRoundedIcon />, premium: <CrownIcon /> };
    const label = isFree ? t('navigation.account.upgradePlan') : t('navigation.account.currentPlan', { plan: upperFirst(plan) });
    // on mobile the centered logo leaves room for the icon only, a round badge like the avatar
    const compact = this.state.isMobile;

    return <Button
      variant="outlined"
      size="small"
      disableElevation
      className={classNames(classes.planBtn, isFree && classes.planUpgradeBtn, compact && classes.planBtnCompact, compact && !isFree && classes.planBtnBadge)}
      component={RouterLink}
      to="/profile/plans"
      onClick={() => this.trackPlanButtonClick(plan, isFree)}
      aria-label={label}
      startIcon={icons[plan]}
    >
      {!compact && label}
    </Button>;
  }

  renderSelectors = (inDrawer) => {
    const { classes } = this.props;
    const wrapperStyle = inDrawer
      ? { padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 8 }
      : { display: 'flex', alignItems: 'center', minWidth: 0, flexShrink: 1 };
    const inputClasses = inDrawer
      ? { input: classes.drawerSelectInput, notchedOutline: classes.drawerSelectOutline }
      : { input: classes.selectInput, notchedOutline: classes.selectOutline };
    const iconClass = inDrawer ? classes.drawerSelectIcon : classes.selectIcon;
    return (
      <div style={wrapperStyle}>
        {/* nothing to pick yet: the selector's place offers the first step instead */}
        {!this.hasTranslationLanguage() ?
          <Button
            variant="outlined"
            className={inDrawer ? classes.drawerAddLanguageBtn : classes.addLanguageBtn}
            component={RouterLink}
            to={{ pathname: '/', state: { createLanguage: true } }}
            startIcon={<AddIcon />}
            fullWidth={inDrawer}
          >
            {this.props.t('navigation.noLanguageHint.button')}
          </Button>
        :
        <FormControl variant="outlined" className={classNames(
            classes.formControl, !inDrawer && !this.state.open && classes.searchOpen)}
            {...(inDrawer ? { fullWidth: true, size: 'small' } : {})}
            style={!inDrawer ? { minWidth: 0, flexShrink: 1 } : { margin: '12px 0' }}
          >
            {inDrawer && <InputLabel id="drawer-language-label">{this.props.t('navigation.language')}</InputLabel>}
            {/* outlined on the Select itself: the theme's standard default would trim the padding of
                the outlined input it is given */}
            <Select
              variant="outlined"
              labelId={inDrawer ? "drawer-language-label" : undefined}
              placeholder={this.props.t('navigation.language')}
              value={this.props.shop.shop.edit_language ? this.props.shop.shop.edit_language : 'Language'}
              onChange={e => this.requestContextSwitch('language', e.target.value)}
              renderValue={(val) => <span style={{fontWeight: 400, display: 'flex', alignItems: 'center'}}>
                  {!inDrawer && <TranslateOutlinedIcon style={{fontSize: 14, marginRight: 4, opacity: 0.6, flexShrink: 0}} />}
                  {this.props.languages.languages.find(x => x.base == true)?.name}
                  <ArrowForwardIosOutlined style={{fontSize: 10, margin: '0 4px'}} />
                  {(this.props.languages.languages.length > 1 && this.props.languages.languages.find(x => x.id == this.props.shop.shop.edit_language)) ? `${this.props.languages.languages.find(x => x.id == this.props.shop.shop.edit_language).name}` : this.props.t('navigation.language')}
                </span>
              }
              classes={{
                icon: iconClass,
              }}
              MenuProps={{
                classes: {
                  paper: classes.selectMenu
                }
              }}
              input={
                <OutlinedInput
                  className={`current-language-select`}
                  classes={inputClasses}
                  label={inDrawer ? this.props.t('navigation.language') : undefined}
                  placeholder={this.props.t('navigation.language')}
                  margin="dense"
                  name="language"
                  data-tour="language-selector"
                  id={inDrawer ? "drawer-language" : "outlined-language"}
                />
              }>
              <MenuItem disabled={true} value={'Language'}><em>{this.props.t('navigation.fromLanguageTo', { name: this.props.languages.languages.find(x => x.base == true)?.name })} </em></MenuItem>
              {
                this.props.languages.languages.map((item, i) => {
                  if(!item.base && !item.removed_on_shopify) {
                    return <MenuItem key={`language-item-${i}`} value={item.id}>{item.name}</MenuItem>
                  }
                })
              }
            </Select>
          </FormControl>
        }

        {/* the hover says why the switch is greyed here; a disabled select fires no events, so the
            tooltip sits on the form control around it */}
        <Tooltip title={this.isThemeRelevantRoute() ? '' : this.themeSwitchDisabledHint()} arrow>
        <FormControl variant="outlined" size="small" className={classNames(
          classes.formControl)} style={inDrawer ? { margin: '0 0 12px 0' } : {marginLeft: 16, minWidth: 0, flexShrink: 1}}>
          {inDrawer && <InputLabel id="drawer-theme-label">{this.props.t('navigation.theme')}</InputLabel>}
          <Select
            variant="outlined"
            labelId={inDrawer ? "drawer-theme-label" : undefined}
            className={classNames('current-theme-select', !inDrawer && 'mobile-context-item')}
            placeholder={this.props.t('navigation.theme')}
            value={this.props.themes.edit_theme}
            onChange={this.handleSelectTheme}
            disabled={!this.isThemeRelevantRoute()}
            renderValue={(val) => {
              const themeName = this.props.themes.themes.find(x => x.id == val)?.name || this.props.t('navigation.selectTheme', 'Select');
              if (inDrawer) {
                return <span style={{fontWeight: 400}}>{themeName}</span>;
              }
              return <span style={{fontWeight: 400, display: 'flex', alignItems: 'center', minWidth: 0}}>
                <PaletteOutlinedIcon style={{fontSize: 14, marginRight: 4, opacity: 0.6, flexShrink: 0}} />
                Theme:&nbsp;
                <span className="context-label-wrapper">
                  <span className="context-label">{themeName}</span>
                </span>
              </span>;
            }}
            classes={{
              icon: iconClass,
            }}
            MenuProps={{
              classes: {
                paper: classes.selectMenu
              }
            }}
            input={
              <OutlinedInput
                classes={inputClasses}
                label={inDrawer ? this.props.t('navigation.theme') : undefined}
                placeholder={this.props.t('navigation.theme')}
                margin="dense"
                name="theme"
                data-tour="theme-selector"
                id={inDrawer ? "drawer-theme" : "outlined-theme"}
              />
            }>
            <MenuItem disabled={true} value={'Theme'}><em>{this.props.t('navigation.theme')}</em></MenuItem>
            {
              this.props.themes.themes.map((item, i) => {
                return <MenuItem key={`theme-item-${i}`} value={item.id} style={{fontWeight: item.role === 'main' ? '500' : 'initial'}}>{item.role === 'main' ? `${item.name} <- main theme` : item.name}</MenuItem>
              })
            }
          </Select>
        </FormControl>
        </Tooltip>
      </div>
    );
  }

  render() {
    if(this.state.renderError) {
      return <AppLoadError message={this.state.renderError?.message} />
    }

    const { t, classes, theme } = this.props;
    const { auth, anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const isDark = theme.palette.mode === 'dark';

    let rechargeConfirmation = null
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('recharge_success')) {
      let usedPlan = urlParams.get('recharge_success')
      let usedWords = 0
      if(usedPlan == 'basic' || usedPlan == 'business' || usedPlan == 'professional') {
        if(usedPlan == 'basic') {
          usedWords = '10 000'
        } else if(usedPlan == 'business') {
          usedWords = '20 000'
        } else if(usedPlan == 'professional') {
          usedWords = '50 000'
        }
        rechargeConfirmation = {
          plan: usedPlan,
          words: usedWords
        }
      }
    }

    
    if(this.props.shop.get_shop_pending === true || this.props.languages.get_languages_pending === true || this.props.themes.get_themes_pending === true) {
      return (
        <div style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 10000000000000,
          width: '100%',
          width: '100vw',
          height: '100vh',
          background: 'var(--ly-content-bg2)',
        }}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ 
              minHeight: '100vh',
              height: '100vh',
              background: 'var(--ly-splash-vignette)',
            }}
          >
            <Grid size={12} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
              <Logo />
              <LoadingIndicator
                withLogo={false}
                pending={true}
                loadingType={'initializing'}
                /*
                styles={{
                  root: classes.loadingIndicatorRoot,
                  circularProgress: classes.circularProgress,
                }}
                */
              />
            </Grid>   
          </Grid> 
        </div>
      )
    }
    // the reducer stores a failed answer as error object ({message, action, level}); without a shop the layout below can't render
    if(this.props.shop.error || !this.props.shop.shop || !this.props.shop.shop.url) {
      const message = this.props.shop.error ? this.props.shop.error.message : null;
      // the backend answers an expired session with {error: 'Not logged in'}
      return <AppLoadError message={typeof message === 'string' ? message : (message && message.error) || null} />
    }
    // without the language list there is no base language, and the header can't render
    if(this.props.languages.error === true) {
      return <AppLoadError kind={this.props.languages.error_kind} message={this.props.languages.error_message} />
    }

    const currentLanguage = this.props.shop.shop.edit_language
    const selectableLanguages = this.props.languages.languages.filter(x => x.base === false && !x.removed_on_shopify)
    if(currentLanguage == 'Language') {
      if(selectableLanguages.length > 0) {
        this.props.setEditLanguage(selectableLanguages[0].id)
      }
    } else {
      if(selectableLanguages.length > 0) {
        if(!selectableLanguages.find(x => x.id == currentLanguage)) {
          this.props.setEditLanguage(selectableLanguages[0].id)
        }
      } else {
        this.props.setEditLanguage('Language')
      }
    }

    return (
      <React.Fragment>
        {
          rechargeConfirmation &&
          <RechargeConfirmation
            plan={rechargeConfirmation.plan}
            words={rechargeConfirmation.words}
          />
        }
        <CssBaseline />
        <div className={classNames(classes.root, this.state.open && 'open-sidebar')}>

          <AppBar
            position="absolute"
            className={classNames(classes.appBar, this.state.open && !this.state.isMobile && classes.appBarShift)}
            elevation={0}
          >
            <Toolbar disableGutters={this.state.isMobile ? false : !this.state.open} className={classes.toolbar}>

              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.state.isMobile && this.state.open ? this.handleDrawerClose : this.handleDrawerOpen}
                className={classNames(
                  classes.menuButton,
                  this.state.open && !this.state.isMobile && classes.hidden,
                )}
                size="large">
                <MenuIcon />
              </IconButton>

              <RouterLink to="/" className={classNames(classes.appBarLogo, this.state.open && !this.state.isMobile && classes.hidden)}>
                <img className="logo-img" src="/langify-logo-white.svg" style={{width: 110}} alt={"logo"}/>
              </RouterLink>

              {/*
              <div className={classNames('search-form', classes.hideSmDown, classes.search, !this.state.open && classes.searchOpen)}>
                <Search theme={this.props.themes.edit_theme} />
              </div>
              */}

              {!this.state.isMobile && this.renderSelectors()}


              <div className={classes.grow} />
              

              {/*
              <IconButton className="start-tutorial-btn" color="inherit">
                <InfoOutlinedIcon />
              </IconButton>
              */}

              {this.renderPlanButton()}

              <Button className={classNames(classes.hideSmDown, classes.backToStoreBtn)} href={`https://${this.props.shop.shop.url}`} target="_blank" color="inherit">
                {this.props.shop.shop.url.replace('.myshopify.com', '')}
              </Button>
              <div>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : undefined}
                  aria-haspopup="true"
                  onClick={this.handleMenu}
                  color="inherit"
                  className={classNames(classes.profileDropdownTrigger)}
                  size="large">
                  <Avatar className={classNames('xxx', classes.avatar)}>
                    { this.props.shop.shop.url.substring(0, 2).toUpperCase() }
                  </Avatar>
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={this.handleClose}
                  classes={{paper: classes.profileMenu}}
                >
                  <MenuItem>
                    <a href={`https://${this.props.shop.shop.url}/admin`} target="_blank" style={{textDecoration: 'none', color: 'inherit'}}>
                      <ArrowBackOutlined /> {t('navigation.account.backToShopify')}
                    </a>
                  </MenuItem>
                  <MenuItem onClick={this.logout}>{t('navigation.account.logout')}</MenuItem>
                </Menu>               
              </div>

            </Toolbar>
          </AppBar>
          
          
          

          <Drawer
            className="sidebar-drawer"
            variant={this.state.isMobile ? "temporary" : "permanent"}
            classes={{
              paper: classNames(classes.drawerPaper, !this.state.isMobile && !this.state.open && classes.drawerPaperClose),
            }}
            open={this.state.isMobile ? this.state.open : true}
            onClose={this.handleDrawerClose}
            ModalProps={{ keepMounted: true }}
          >
            <div className={classes.sidebarHeader}>
              <div className={classes.toolbarIcon}>
                <RouterLink to="/" className={classNames('logo-img', classes.sidebarLogo)}>
                  <img src={isDark ? "/langify-logo-white.svg" : "/langify-logo-black.svg"} style={{width: 110}} alt={"langify logo"}/>
                </RouterLink>
                <IconButton onClick={this.handleDrawerClose} size="large">
                  <ChevronLeftIcon />
                </IconButton>
              </div>
              <Divider />
            </div>
            <div className={classes.sidebarWrapper}>
              {this.state.isMobile && <React.Fragment>{this.renderSelectors(true)}<Divider /></React.Fragment>}
              <div className={classNames('search-form', classes.search)}>
                <ErrorBoundary>
                  <Search theme={this.props.themes.edit_theme} />
                </ErrorBoundary>
              </div>
              <Divider />
              <List className="side-menu">
                <MainListItems 
                  onboarding={!this.hasTranslationLanguage()}
                  plan={this.props.shop.shop.charge.name}
                  shop={this.props.shop}
                  langifyFeatures={this.props.langifyFeatures}
                  customStyle={classes.sidebarItemIcon}
                  isDrawerOpen={this.state.open}
                />
              </List>
              <Divider />
              <List className="side-submenu">
                <SecondaryListItems isDrawerOpen={this.state.open} />
              </List>
            </div>
          </Drawer>
          <main 
            id="mainFrame" 
            ref={this.setMainFrameRef} 
            className={classNames(classes.content)}
          >
            {this.state.isMobile && this.hasTranslationLanguage() && (
              <div className={classes.mobileContextBar}>
                <span className={classNames(classes.mobileContextItem, 'mobile-context-item')} onClick={() => this.handleDrawerOpen('drawer-language')}>
                  <TranslateOutlinedIcon style={{fontSize: 14, marginRight: 4, opacity: 0.6, flexShrink: 0}} />
                  <span style={{overflow: 'hidden', textOverflow: 'ellipsis', flexShrink: 1, minWidth: 0}}>
                    {this.props.languages.languages.find(x => x.base)?.name}
                  </span>
                  <ArrowForwardIosOutlined style={{fontSize: 10, margin: '0 4px', opacity: 0.5, flexShrink: 0}} />
                  <span style={{flexShrink: 0}}>
                    {this.props.languages.languages.find(x => x.id == this.props.shop.shop.edit_language)?.name || 'Language'}
                  </span>
                </span>
                <span className={classNames(classes.mobileContextItem, 'mobile-context-item')} onClick={() => this.handleDrawerOpen('drawer-theme')}>
                  <PaletteOutlinedIcon style={{fontSize: 14, marginRight: 4, opacity: 0.6, flexShrink: 0}} />
                  Theme:&nbsp;
                  <span className="context-label-wrapper">
                    <span className="context-label">
                      {this.props.themes.themes.find(x => x.id == this.props.themes.edit_theme)?.name || 'Theme'}
                    </span>
                  </span>
                </span>
              </div>
            )}

            <Parallax y={[-50, 0]}>
              <div className={classNames(classes.mainContentBg, 'hero')} />
            </Parallax>

            <div className={classNames(classes.pageContent, 'page-content')}>
              {this.needsLanguageFirst() ?
                <EmptyView
                  title={t('navigation.noLanguageHint.title')}
                  description={t('navigation.noLanguageHint.description')}
                  bottom={
                    <Button variant="contained" color="primary" component={RouterLink} to={{ pathname: '/', state: { createLanguage: true } }}>
                      {t('navigation.noLanguageHint.button')}
                    </Button>
                  }
                />
              :
              <Switch>
                <Route exact path="/" component={Dashboard} />
                <Route path="/theme" component={NewTheme} />
                <Route path="/static_theme" component={StaticTheme} />
                <Route path="/products" component={Products} />
                <Route path="/collections" component={Collections} />
                {getRoutedTranslatableResourceSections().map(section =>
                  <Route
                    key={section.key}
                    path={`/${section.key}`}
                    render={() => <TranslatableResources section={section} />}
                  />
                )}
                <Route path="/pages" component={Pages} />
                <Route path="/navigation" component={Navigation} />
                <Route path="/blogs" component={Blogs} />
                <Route path="/articles" component={Articles} />
                <Route path="/images" component={Images} />
                <Route path="/shop_metafields" component={ShopMetafields} />
                <Route path="/shop" component={Shop} />
                <RestrictedRoute path="/custom" component={NewCustom} isAuthenticated={this.props.shop.shop.charge.name !== 'free'} />
                <Route path="/sms_notifications" component={SMSNotifications} />
                <Route path="/notifications" component={NewNotifications} />
                <Route exact path="/static" component={Static} />              
                <Route exact path="/static/:id" component={Static} />  
                <Route exact path="/about" component={About} />
                <Route exact path="/login" component={Login} />              
                <Route exact path="/design" component={Design} />          
                <Route exact path="/patchnotes" component={PatchNotes} />
                <Route exact path="/changelog" component={PatchNotes} />  
                <Route exact path="/settings" component={Settings} />
                <RestrictedRoute path="/machinetranslation/bulk" component={BulkSettings} isAuthenticated={hasBulkTranslationAccess(this.props.shop.shop.charge?.name, this.props.shop.shop.langify_features)} />
                <Route exact path="/hidden_admin" component={Admin} />

                <Route exact path="/profile" component={Profile} />
                <Route exact path="/profile/plans" component={ProfilePlans} />
                <Route exact path="/profile/charges" component={ProfileCharges} />
                <RestrictedRoute exact path="/machinetranslation/wordslog" component={WordsLog} isAuthenticated={this.props.shop.shop.charge.name !== 'free'} />
                <RestrictedRoute exact path="/machinetranslation/glossary" component={ProfileGlossary} isAuthenticated={this.props.shop.shop.charge.name !== 'free'} />
                <RestrictedRoute exact path="/machinetranslation/settings" component={BulkConfiguration} isAuthenticated={this.props.shop.shop.charge.name !== 'free'} />
                <RestrictedRoute path="/profile/tickets/:id?" component={ProfileTickets} isAuthenticated={this.props.shop.shop.charge.name === 'premium'} />

                <Route path="/metaobjects/:id?/:subId?" component={MetaObjects} /> 

                <Route path="/appembeds/:id?/:subId?" component={AppEmbeds} />              
                <Route path="/appintegrations" component={AppIntegrations} />        
                <Route path="/apps/size_chart_avada" component={SizeChartApp} />
                <Route path="/apps/:id?" component={AppIntegration} />
                <Route exact path="/recommended_apps" component={RecommendedApps} />      
              </Switch>
              }
            </div>
            
            <div className={'footer'}>
              <div className={classNames('main-footer-bg')}>
                <Typography component="p" variant="caption" style={{textAlign: "center", color: 'var(--ly-footer-text)', marginBottom: 8, width: '100%'}}>
                  <img className="logo-img" src={isDark ? "/langify-logo-light.png" : "/langify-logo-dark.png"} style={{width: 150, opacity: .15, marginBottom: 20, marginTop: 40}} alt={"logo"}/>
                  <br />
                  Copyright &copy; {new Date().getFullYear()} Langify GmbH & Ko. KG
                </Typography>
              </div>             
            </div>

            <LoadingIndicator pending={this.props.themes.change_edit_theme_pending}/>
            <ImportReviewDialog />
          </main>
        </div>
        {/*<BulkTranslationStatusCard />*/}
        <BulkTranslationSnackbarManager />
        {this.renderContextSwitchPrompt()}

        <Dialog
          open={this.state.showNewChargeDialog}
          onClose={() => { this.setState({showNewChargeDialog: false}); }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          BackdropProps={{
            style: {
              backgroundColor: 'var(--ly-backdrop)'
            }
          }}
        >
          <DialogTitle id="alert-dialog-title">{this.props.t('system.updatedChargeAvailable')}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            Your charge has been updated. The  new charge will be ${this.props.shop.shop.updated_charge && this.props.shop.shop.updated_charge.toFixed(2)}/month.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.updateCharge} download color="primary">{this.props.t('system.continue')}</Button>
          </DialogActions>
        </Dialog>
        <SupportSpeedDial />
        {/* TODO: get usable value from backend */}
        {true === true &&
          <SatisfactionQuote />
        }
        {/**
         * Shopify Markets Update Information
         * TODO: Remove again in the future
         */}
        {/*this.state.showUpdateInformation && !window.localStorage.getItem('ly_dismissed_markets_update_information') &&
          <Dialog
            open={true}
            disableBackdropClick={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            BackdropProps={{
              style: {
                backgroundColor: 'rgba(255, 255, 255, .5)'
              }
            }}
          >
            <DialogTitle id="alert-dialog-title">Update information</DialogTitle>
            <DialogContent>
            We recently released an update to fully support new Shopify features.
The update includes a few breaking changes affecting the language switcher and the language detection. Please contact our support if language selecting should not behave as usual.
            </DialogContent>
            <DialogActions>
              <Button onClick={() => {this.setState({showUpdateInformation: false}); window.localStorage.setItem('ly_dismissed_markets_update_information', true)}} variant="contained" color="primary">Got it</Button>
            </DialogActions>
          </Dialog>
          */}
      </React.Fragment>
    );
  }
}

const styles = theme => ({
  root: {
    display: 'flex',
  },
  profileMenu: {
    top: '4px !important',
  },
  toolbar: {
    paddingRight: 24,
    //backgroundColor: 'rgba(26, 35, 126, .9)',
    backgroundColor: theme.palette.primary.main,
    backgroundImage: 'var(--ly-banner-gradient)',
    [theme.breakpoints.down('md')]: {
      paddingRight: 0,
    }
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    //zIndex: theme.zIndex.drawer + 1,
    boxShadow: '0px 0px 10px rgba(0,0,0,.35)',
    backgroundColor: theme.palette.background.paper,
    zIndex: 100,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarLogo: {
    '@media (max-width: 750px)': {
      position: 'absolute',
      left: 0,
      right: 0,
      textAlign: 'center',
      pointerEvents: 'none',
      '& img': {
        pointerEvents: 'auto',
      },
    }
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth})`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
    },
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 24,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 4,
    }
  },
  hidden: {
    display: 'none',
  },
  hideSmDown: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    }
  },
  hideXsDown: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  title: {
    flexGrow: 1,
  },
  sidebarWrapper: {
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'absolute',
    top: 64,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : 'rgba(235, 235, 235, 1)',
    [theme.breakpoints.down('sm')]: {
      top: 56,
    }
  },
  sidebarHeader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    //backgroundColor: '#fff',
    zIndex: 1010,
    '& hr': {
      marginTop: -1,
    }
  },
  sidebarItemIcon: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
      //marginRight: 0,
    }
  },
  sidebarLogo: {
    position: 'absolute',
    left: 0,
    width: drawerWidth,
    textAlign: 'center',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    overflowX: 'hidden !important',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  // the frame starts below the app bar instead of behind it, so its scrollbar is reachable along
  // its whole length (a long theme put the thumb under the header)
  content: {
    position: 'relative',
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: 64,
    height: 'calc(100vh - 64px)',
    overflow: 'auto !important',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      marginTop: 56,
      height: 'calc(100vh - 56px)',
    },
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },

  button: {
    margin: theme.spacing(1),
  },

  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.black, 0),
    '&:hover': {
      backgroundColor: theme.palette.mode === 'dark'
        ? alpha(theme.palette.common.white, 0.08)
        : alpha(theme.palette.common.black, 0.02),
    },
    marginRight: 0,
    marginLeft: 0,
    paddingLeft: theme.spacing(2),
    paddingTop: 2,
    paddingBottom: 2,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 12px',
    }
  },
  searchOpen: {
    marginLeft: theme.spacing(6),
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(6),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },

  targetLangSelector: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 32,
    paddingLeft: 8,    
  },

  selectOutline: {
    borderColor: 'rgba(255, 255, 255, 0.23) !important',
  },
  // right inset and arrow position as the standard variant had them before the selects went outlined
  selectIcon: {
    right: 0,
    color: 'rgba(255, 255, 255, 0.54) !important',
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.3) !important',
    },
  },
  selectInput: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 6,
    // MUI's outlined select sets its 32px with a doubled class
    paddingRight: '24px !important',
    color: '#fff',
    // MUI's disabled fill colour is meant for text on paper; on the header gradient it vanishes
    '&.Mui-disabled': {
      WebkitTextFillColor: 'rgba(255, 255, 255, 0.5)',
    },
    maxWidth: 500,
    width: 'auto',
    fontWeight: 300,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  drawerSelectOutline: {
    borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.23) !important' : 'rgba(0, 0, 0, 0.23) !important',
  },
  drawerSelectIcon: {
    right: 0,
    color: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.54) !important' : 'rgba(0, 0, 0, 0.54) !important',
  },
  drawerSelectInput: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: '24px !important',
    color: theme.palette.text.primary,
    width: '100%',
    fontWeight: 400,
    fontSize: '0.875rem',
  },
  loadingProgress: {
    color: theme.palette.text.primary,
  },
  selectMenu: { 
    top: '14px !important',
  },

  // the box of the language and theme selectors next to it
  planBtn: {
    height: 43,
    marginLeft: 16,
    marginRight: 16,
    padding: '0 12px 0 8px',
    fontSize: 16,
    fontWeight: 400,
    textTransform: 'initial',
    whiteSpace: 'nowrap',
    color: '#fff',
    borderColor: 'rgba(255, 255, 255, 0.23)',
    '&:hover': { borderColor: 'rgba(255, 255, 255, 0.5)', backgroundColor: 'rgba(255, 255, 255, 0.08)' },
    '& .MuiButton-startIcon': { marginLeft: 0, marginRight: 6 },
    '& .MuiButton-startIcon > svg': { fontSize: 24, color: '#ffaf23' },
  },
  // the language selector's box, for the button that stands in for it
  addLanguageBtn: {
    height: 43,
    padding: '0 12px 0 8px',
    fontSize: 16,
    fontWeight: 400,
    textTransform: 'initial',
    whiteSpace: 'nowrap',
    color: '#fff',
    borderColor: 'rgba(255, 255, 255, 0.23)',
    '&:hover': { borderColor: 'rgba(255, 255, 255, 0.5)', backgroundColor: 'rgba(255, 255, 255, 0.08)' },
    '& .MuiButton-startIcon': { marginLeft: 0, marginRight: 4 },
  },
  drawerAddLanguageBtn: {
    margin: '12px 0 0 0',
    textTransform: 'initial',
  },
  planBtnCompact: {
    width: 40,
    height: 40,
    minWidth: 0,
    marginLeft: 0,
    marginRight: 0,
    padding: 0,
    borderRadius: '50%',
    '& .MuiButton-startIcon': { margin: 0 },
    '& .MuiButton-startIcon > svg': { fontSize: 22 },
  },
  // the paid plans' icons are badges already, on mobile they are the whole button
  planBtnBadge: {
    border: '1px solid #3a20cd',
    overflow: 'hidden',
    '&:hover': { borderColor: '#3a20cd', backgroundColor: 'transparent', opacity: 0.85 },
    // the badge circle spans 20 of the icon's 24 units: 48px draws it at the avatar's 40
    '& .MuiButton-startIcon > svg': { fontSize: 48 },
  },
  planUpgradeBtn: {
    borderColor: '#ffaf23',
    '&:hover': { borderColor: '#ffaf23', backgroundColor: 'rgba(255, 175, 35, 0.12)' },
    ...glintOnHover,
  },
  backToStoreBtn: {
    textTransform: 'initial',
    whiteSpace: 'nowrap',
  },
  profileDropdownTrigger: {
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1)
    }
  },
  // same look as the avatar on the profile page
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  mainContentBg: {
    [theme.breakpoints.down('sm')]: {
      top: theme.spacing(7)
    }
  },

  mobileContextBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 12px',
    margin: '-24px -24px 24px -24px',
    [theme.breakpoints.down('sm')]: {
      margin: '-8px -8px 24px -8px',
    },
    backgroundColor: theme.palette.mode === 'dark' ? '#2a2a2a' : '#f5f5f5',
    borderBottom: `1px solid ${theme.palette.divider}`,
    cursor: 'pointer',
    fontSize: 13,
    color: theme.palette.text.secondary,
    '&:active': {
      backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#eee',
    },
  },
  mobileContextItem: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    maxWidth: '50%',
    minWidth: 0,
  },
  pageContent: {
    minHeight: 350
  },

  loadingIndicatorRoot: {
    backgroundColor: 'none !important',
    position: 'relative !important',
    left: '0px !important',
    padding: '24px !important',
  },
  circularProgress: {
    color: '#red !important', 
    margin: '24px !important',
  }, 
});

// A language switch must not interrupt a write that carries the edit language. Every slice
// takes part by naming its flag save_*_pending or create_*_pending; only slices whose writes hold
// no per-language text opt out here. The registry sections (shop page) keep one save_pending each
// a level down.
const LANGUAGE_WRITE_FLAG = /^(save|create)_(\w+_)?pending$/;
const LANGUAGE_FREE_SLICES = new Set(['config', 'appIntegrations', 'glossary', 'ticketsystem']);
const hasLanguageWrite = (slice) => !!slice && typeof slice === 'object' &&
  Object.entries(slice).some(([key, flag]) => flag === true && LANGUAGE_WRITE_FLAG.test(key));
const isSavingLanguageScoped = (state) => Object.entries(state).some(([name, slice]) =>
  !LANGUAGE_FREE_SLICES.has(name) && (
    hasLanguageWrite(slice)
    || (name === 'translatableResources' && Object.values(slice || {}).some(hasLanguageWrite))
  ));

const mapStateToProps = (state) => {
  const { shop, languages, themes, bulkTranslation, new_theme, static_theme, appEmbeds, editing } = state;
  return {
    shop: shop,
    hasUnsavedEdits: editing.unsavedEdits,
    langifyFeatures: shop.shop.langify_features,
    languages: languages,
    themes: themes,
    shopUrl: shop.shop.url,
    bulkTranslation: bulkTranslation,
    isSavingLanguageScoped: isSavingLanguageScoped(state),
    // app embed translations belong to one theme's settings_data, so a theme switch stops them
    isSavingThemeScoped: new_theme.save_new_theme_pending
      || static_theme.save_static_theme_pending
      || appEmbeds.save_appembeds_pending,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getShop,
      getLanguages,
      getThemes,
      setEditLanguage,
      setEditTheme,
      logout,
      updateSwitcherLanguages,
      getLangifyNotifications,
    },
    dispatch
  );

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withController(withStyles(styles)(withTranslation()(withSnackbar(App))))))